<script>
import {axios, swal} from '../../mixins';

export default {
    name: 'ImageUpload',

    inheritAttrs: false,

    mixins: [axios, swal],

    props: {
            url: {
                required: true,
                type: String,
                },
            deleteUrl: {
                required: true,
                type: String,
            },
            value: {
                required: false,
                type: String,
                default: '',
            },
        },

        data() {
            return {
                image: this.value,
            };
        },

        activated() {
            this.image = this.value;
        },

        watch: {
            value(newValue) {
                this.image = newValue;
            },
        },

        methods: {
            triggerUploadFileExplorer() {
                this.$refs.file.click();
            },
            doUpload(event) {
                let files = event.target.files;
                if (files.length != 1) {
                    return;
                }

                let data = new FormData();
                data.append('_token', this.csrf());
                data.append('upload', event.target.files[0]);

                this.swalLoading('', 'Uploading image...');

                this.post(this.url, data, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }).then((response) => {
                    this.image = response.data.url;

                    this.swalClose();
                    this.swalSuccess('', `Successfully uploaded image image`);
                }).catch(() => {
                    this.$refs.file.value = '';

                    this.swalClose();
                    this.swalError('', `Failed to upload image`);
                });
            },
            deleteUpload() {
                this.swalConfirm('Confirm', 'Please confirm you wish to delete this image').then((result) => {
                    if (result.value) {
                        this.swalLoading('', `Deleting image...`);

                        // Send axios to delete image
                        this.post(this.deleteUrl, {
                            url: this.image,
                        }).then(() => {
                            this.image = '';
                            this.$refs.file.value = '';

                            this.swalClose();
                            this.swalSuccess('', `Successfully deleted image`);
                        }).catch(() => {
                            this.swalClose();
                            this.swalError('', `Failed to delete image`);
                        });
                    }
                });
            },
        },
    };
</script>

<template>
    <div class="flex flex-col">
        <div class="flex flex-row">
              <input v-bind="$attrs" class="form-input disabled appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded py-3 px-4" readonly="readonly"
                     :value="image">
              <input class="hidden" type="file" ref="file" @change="doUpload">
              <button @click="triggerUploadFileExplorer" type="button" class="ml-1 bg-green-light text-white font-bold rounded border-green hover:border-green-dark hover:bg-green hover:text-white border-b-2 border-r-2 active:border-b-none active:border-r-none py-2 px-3 inline-flex items-center flex flex-col" size="sm" color="teal">
                <i class="fad fa-upload"></i><span class="hidden sm:inline">Upload</span>
              </button>

              <button @click="deleteUpload" type="button" class="ml-1 bg-red-light text-white font-bold rounded border-red hover:border-red-dark hover:bg-red hover:text-white border-b-2 border-r-2 active:border-b-none active:border-r-none py-2 px-3 inline-flex items-center flex flex-col" size="sm" color="teal">
                <i class="fad fa-trash"></i><span class="hidden md:inline">Delete</span>
              </button>

        </div>

        <div class="pt-2">
            <img v-if="image" class="h-auto max-w-full" :src="image" alt="File Uploaded">
        </div>
    </div>
</template>
